import { useQuery } from 'data-fetching-client';
import getLang from 'I18n/utils/getLang';
import PortalIdParser from 'PortalIdParser';
import { useMemo } from 'react';
import { GET_SEARCH_FILTER_CONFIG_QUERY as PUBLIC_GET_SEARCH_FILTER_CONFIG_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontPublicRpc.dfc.new';
import { GET_SEARCH_FILTER_CONFIG_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontRpc.dfc.new';
const OBJECTIVE_FILTER_FIELD = 'OBJECTIVE';

/**
 * Returns a map of workflow objective key -> localized label, sourced from the
 * backend `OBJECTIVE` search filter config so labels are never redeclared on the
 * frontend. Pass `skip` to avoid firing the request where objectives aren't
 * rendered (e.g. non-workflow-template cards).
 *
 * Uses the public (no-auth) RPC when there is no portal id so listing cards can
 * render on the public storefront without triggering hub-http's portal redirect.
 */
export function useWorkflowObjectiveLabels({
  skip
} = {}) {
  const hasPortalId = Boolean(PortalIdParser.get());
  const {
    data
  } = useQuery(hasPortalId ? GET_SEARCH_FILTER_CONFIG_QUERY : PUBLIC_GET_SEARCH_FILTER_CONFIG_QUERY, {
    variables: {
      language: getLang(),
      productTypes: ['WORKFLOW_TEMPLATE'],
      includeWorkflowTemplates: true
    },
    skip
  });
  return useMemo(() => {
    var _data$result$filterCo, _data$result;
    const options = (_data$result$filterCo = data === null || data === void 0 || (_data$result = data.result) === null || _data$result === void 0 || (_data$result = _data$result.filterConfigs) === null || _data$result === void 0 || (_data$result = _data$result[OBJECTIVE_FILTER_FIELD]) === null || _data$result === void 0 ? void 0 : _data$result.options) !== null && _data$result$filterCo !== void 0 ? _data$result$filterCo : [];
    return Object.fromEntries(options.map(option => [option.value, option.text]));
  }, [data]);
}